// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__25XQG","colMin":"styles_colMin__2K-M-","colCheckbox":"styles_colCheckbox__27pRa"};